// JS dependency
var bootstrap = require('bootstrap');
